import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Seguimiento/filtrarModalNuevoSeguimiento`, method: 'POST', body: values, token: token})
}
